import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-success',
  standalone: false,
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss',
})
export class PaymentSuccessComponent implements OnInit {
  ngOnInit(): void {}

  constructor(private apiService: ApiService, private route: ActivatedRoute) {
    this.paymentCallback(this.route.snapshot.params['payRef']);
  }

  paymentCallback(response: any) {
    const url = '/payment/acknowledge?orderId=' + response;
    this.apiService.post(url, {}).subscribe(
      (response) => {
      },
      (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      }
    );
    return;
  }
}
